module.exports = __webpack_public_path__ + "assets/HotKeys.f832ff845c45251dd5ec0e3a1affee6f.strings";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/ru-lproj/HotKeys.strings
// module id = 1035
// module chunks = 0